import { connect } from "react-redux";
import PostedProjects from "your_projects/components/posted_projects";

const mapStateToProps = ({ categories, user, industry }) => {
  return {
    categories: categories.data,
    industries: industry.data,
    user: user.profile_data,
  };
};

export default connect(mapStateToProps)(PostedProjects);
